import React from 'react';
import { Button, Tooltip } from 'antd';
import { Sun, Moon } from 'lucide-react';
import { defaultColors } from '@/themes/antd-theme';

/**
 * Theme Toggle Button Component
 * Switches between light and dark mode with smooth transition
 */
const ThemeToggle = ({ isDark, onToggle, className = '' }) => {
  // Dark mode aware colors
  const bgColor = isDark ? defaultColors.grey[700] : defaultColors.grey[100];
  const iconColor = isDark ? defaultColors.grey[100] : defaultColors.grey[700];

  return (
    <Tooltip title={isDark ? 'Switch to Light Mode' : 'Switch to Dark Mode'} placement="bottom" zIndex={9999}>
      <Button
        type="text"
        shape="circle"
        icon={
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            {isDark ? (
              <Sun size={23} className="transition-transform hover:rotate-45 duration-300" style={{ display: 'block', color: iconColor }} />
            ) : (
              <Moon size={23} className="transition-transform hover:-rotate-12 duration-300" style={{ display: 'block', color: iconColor }} />
            )}
          </div>
        }
        onClick={onToggle}
        style={{
          backgroundColor: bgColor,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 0,
        }}
        className={`transition-all duration-300 ${className}`}
        aria-label={isDark ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
      />
    </Tooltip>
  );
};

export default ThemeToggle;
